import { useCallback } from "react";
import { productImpressionManager } from "../utils/ProductImpressionManager";

type ProductImpressionTracker = {
  onProductView: (sku: string) => void;
};

export const useProductImpression = (): ProductImpressionTracker => {
  const onProductView = useCallback((sku: string) => {
    productImpressionManager.addImpression(sku);
  }, []);

  return {
    onProductView
  };
};
